import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
  Skeleton,
  CircularProgress,
  Link,
} from "@mui/material";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { useSteps } from "shared/features/subscription/stepsSlice";
import { Steps, stepsInfos } from "components/Steps";
import { FormStepper } from "components/FormStepper";
// import { useGetAbrirFecharInscricaoQuery, useGetSubscribeTextQuery } from "shared/features/api/subscription/formSlice";
import { useGetInscricoesAbertasQuery } from "shared/features/api/inscricao/inscricaoSlice";
import parse from "html-react-parser";
import { StepThree } from "components/Steps/StepThree";
// import menPng from "../../assets/dbc-background-men.jpg";
import { Button } from "@mui/material";
import { ArticleOutlined, Info } from "@mui/icons-material";
import { useGetInformacaoQuery } from "shared/features/api/informacao/informacaoSlice";

export const Subscription = () => {
  const { current, data } = useSelector(useSteps);
  const { StepOne, StepTwo } = Steps;
  const baseUrl = window.location.href.split("/subscription")[0];
  const { data: informacoesVemSer, isLoading } = useGetInformacaoQuery();
  const { data: inscricoesAbertas, isLoading: inscricoesLoading } =
    useGetInscricoesAbertasQuery();

  if (inscricoesLoading) {
    return (
      <Box
        sx={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#1E62FE",
          color: "whitesmoke",
        }}
      >
        <CircularProgress size="3rem" color="inherit" />
      </Box>
    );
  }

  return (
    <Box
      component={motion.div}
      initial={{
        backgroundColor: "#040C2C",
      }}
      animate={{
        backgroundColor: "#1E62FE",
      }}
      transition={{ duration: 0.5 }}
      sx={{
        width: "100%",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right",
        minHeight: "100vh",
        color: "whitesmoke",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          component={motion.div}
          initial={{
            opacity: 0,
            x: -50,
            backgroundColor: "#F2F2F2",
            padding: 10,
            borderRadius: 5,
            margin: 0,
          }}
          animate={{
            opacity: 1,
            x: 0,
            backgroundColor: "#F2F2F2",
            padding: 20,
            borderRadius: 10,
            margin: "20px 0",
          }}
          transition={{ duration: 0.5 }}
        >
          {!inscricoesAbertas ? (
            <Grid container spacing={2}>
              <Grid item xs={12} pb={2}>
                <Grid item xs={12} mb="24px">
                  <Button
                    component={Link}
                    target="_blank"
                    referrerPolicy="no-referrer"
                    href={informacoesVemSer?.linkEdital}
                    variant="contained"
                    endIcon={<ArticleOutlined />}
                  >
                    Confira o Edital do Vem Ser
                  </Button>

                  <Box
                    display="flex"
                    alignItems="center"
                    flexDirection="column"
                    justifyContent="center"
                    height="100%"
                    pt="2rem"
                    color="black"
                  >
                    <Info fontSize="large" color="info" />
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mt={2}
                      textAlign="center"
                    >
                      As inscrições estão encerradas!
                    </Typography>
                    <Typography
                      fontWeight={400}
                      fontSize={18}
                      maxWidth={600}
                      mt={2}
                      textAlign="center"
                    >
                      Acompanhe as nossas redes sociais para ter informações
                      sobre novas edições do Vem Ser DBC.{" "}
                      <strong>
                        Agradecemos o seu interesse e te esperamos na próxima
                        edição!
                      </strong>
                    </Typography>
                    <Button
                      href={`${baseUrl}`}
                      variant="outlined"
                      sx={{ marginTop: "2rem" }}
                    >
                      Voltar para o início
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={12} lg={12} m="0 auto" pb={2}>
                <Grid item xs={12} mb="24px">
                  <Button
                    component={Link}
                    target="_blank"
                    referrerPolicy="no-referrer"
                    href={informacoesVemSer?.linkEdital}
                    variant="contained"
                    endIcon={<ArticleOutlined />}
                  >
                    Confira o Edital do Vem Ser
                  </Button>
                </Grid>

                <FormStepper activeStep={current} steps={stepsInfos} />
              </Grid>
              {current === 0 && (
                <Grid item xs={12} lg={6}>
                  <StepOne />
                </Grid>
              )}
              {current === 1 && (
                <Grid item xs={12}>
                  <StepTwo />
                </Grid>
              )}
              {current === 2 && (
                <Grid item xs={12}>
                  <StepThree />
                </Grid>
              )}
              {current === 0 && (
                <Grid item xs={12} lg={6}>
                  {isLoading ? (
                    <Skeleton variant="rectangular" width="100%" height={361} />
                  ) : (
                    <Paper
                      elevation={3}
                      sx={{
                        p: 3,
                        backgroundColor: "#052547", // Fundo azul escuro sólido (sem imagem)

                        // Tamanho do container (inalterado)
                        height: "100%",
                        minHeight: 460,
                        maxHeight: 460,
                        overflowY: "auto",
                        borderRadius: "8px",

                        // Navegadores -- barra de rolagem estilizada
                        scrollbarWidth: "thin",
                        scrollbarColor: "rgba(255, 255, 255, 0.3) transparent",
                        "&::-webkit-scrollbar": {
                          width: "6px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "transparent",
                          my: 1.5,
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "rgba(255, 255, 255, 0.25)",
                          borderRadius: "10px",
                          "&:hover": {
                            background: "rgba(255, 255, 255, 0.5)",
                          },
                        },
                      }}
                    >
                      <Typography
                        variant="h6"
                        component="h2"
                        textAlign="center"
                        color="whitesmoke"
                        fontWeight="normal"
                      >
                        {informacoesVemSer?.titulo}
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          width: "100%",
                          height: "1px",
                          backgroundColor: "rgba(245, 245, 245, 0.3)",
                          my: 1.5,
                        }}
                      />

                      <Box
                        sx={{
                          color: "whitesmoke",
                          fontSize: "0.875rem",
                          lineHeight: 1.35,
                          fontWeight: 400,
                          "& strong, & b": {
                            fontWeight: "normal",
                          },
                          "& p": {
                            mb: 1,
                            fontSize: "0.875rem",
                            lineHeight: 1.35,
                            fontWeight: 400,
                          },
                          "& ul": {
                            pl: 2,
                            m: 0,
                          },
                          "& li": {
                            mb: 0.6,
                            fontSize: "0.875rem",
                            lineHeight: 1.35,
                            fontWeight: 400,
                          },
                        }}
                      >
                        {parse(informacoesVemSer?.conteudo || "")}
                      </Box>
                    </Paper>
                  )}
                </Grid>
              )}
            </Grid>
          )}
        </Box>
      </Container>
    </Box>
  );
};
